module.exports = __webpack_public_path__ + "static/media/2.3acadb45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/2.jpg
// module id = 163
// module chunks = 0